import styled from 'styled-components'
import { inputStyles } from 'components/generic/Input/styles'

export const Select = styled.select`
  ${inputStyles}

  &:disabled {
    opacity: 1;
  }
`
